module.exports = __webpack_public_path__ + "media/images/emblems/Cademario-coat_of_arms-42f5998d505baad5b126d417e6194766.svg";